import { useEffect, useState } from 'react';
import { WixClient, login, logout } from '../auth/auth';
import axios from 'axios';
import { useAppContext, SET_USER, RESET_STATE } from '../context/AppContext';
import { Button } from '@mantine/core';
import { isMobile } from 'react-device-detect';


const API_URL = import.meta.env.VITE_API_URL;

export async function fetchOrCreateUserId(email) {
  try {
    const response = await axios.post(`${API_URL}/check-or-create-user`, { email })
    console.log("### fetchOrCreateUserId, response", JSON.stringify(response));
   /* await fetch('/api/check-or-create-user', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    }); */
    const user = response.data?.user;

    return user?.userId
  } catch (error) {
    console.error('Error fetching userId:', error);
  }
}

export default function LoginBar() {
  const [member, setMember] = useState(null);
  const { dispatch } = useAppContext();

  const handleLogout = () => {
    dispatch({ type: RESET_STATE });
    logout();
  }

  const handleLogin = async () => {
    try {
      await login();
    } catch (error) {
      console.error('Login failed:', error);
      // Show error to user - you might want to use a toast notification here
      alert(`Login failed: ${error.message || 'An error occurred during login. Please check the console for details.'}`);
    }
  }

  async function fetchMember() {
    console.log("####@@@ fetchMember ####@@@");
    try {
      const loggedIn = WixClient.auth.loggedIn();
      
      const { member } = loggedIn
        ? await WixClient.members.getCurrentMember({ fieldsets: ['FULL'] })
        : {};
      
      dispatch({
        type: SET_USER,
        payload: {
          email: member?.loginEmail,
          firstName: member?.contact?.firstName,
          lastName: member?.contact?.lastName,
          nickname: member?.profile?.nickname,
          phone: member?.contact?.phones?.[0],
          zipCode: member?.contact?.zipCodes?.[0],
          loggedIn: loggedIn,
        }
      });
      console.log("####@@@ dispatch SET_USER ####@@@ member = ", JSON.stringify(member));
      setMember(member || undefined);
    } catch (error) {
      console.error('Error fetching member:', error);
    }
  }

  useEffect(() => {
    fetchMember();
  }, []);

  const buttonStyle = isMobile ? {
    position: 'absolute',
    right: 10,
    top: 10,
    borderRadius: '7px',
    paddingLeft: '12px',
    paddingRight: '12px',
  } : {
    position: 'absolute',
    right: 25,
    top: 15,
  }

  return (
    <div>
      {member !== null && (
        <Button
          onClick={() => (WixClient.auth.loggedIn() ? handleLogout() : handleLogin())}
          style={buttonStyle}
          variant="filled"
          color={isMobile ? "lightgray" : "gray"}
        >
          {WixClient.auth.loggedIn() ? 'Logout' : 'Login'}
        </Button>
      )}
    </div>
  );
}
